window.SLDS = window.SLDS || {};

window.SLDS["infographicsGrid"] = function () {
  return {
    currentImage: false,

    init() {
      // Fetch all items
      const items = this.$el.querySelectorAll("[data-image]");

      // Loop through the list items.
      items.forEach((image) => {
        // Get the image URL from the data attribute.
        const imageUrl = image.dataset.image;

        // Check that there is a URL.
        if (imageUrl) {
          // Preload the image.
          const img = new Image();
          img.src = imageUrl;
        }
      });
    },

    updateImage(event) {
      // Get the image URL from the data attribute of the hovered item.
      const image = event.currentTarget.getAttribute("data-image");

      // If there is no image URL, do nothing.
      if (!image) {
        return;
      }

      // If the hovered item has the same image as the current one, do nothing.
      if (this.currentImage === image) {
        return;
      }

      // Get the focal point from the data attribute of the hovered item.
      const focalPoint =
        event.srcElement.parentElement.getAttribute("data-focalpoint");

      // Update the current image.
      this.currentImage = image;

      // Set the front layer's background image to the new image.
      this.$refs.frontLayer.style.backgroundImage = `url('${image}')`;

      // Set the front layer's background position to the focal point.
      this.$refs.frontLayer.style.backgroundPosition = focalPoint;

      // Remove the opacity-0 class to fade in the front layer.
      this.$refs.frontLayer.classList.remove("opacity-0");

      // Listen for the transitionend event on the front layer to know when the fade-in is complete.
      this.$refs.frontLayer.addEventListener(
        "transitionend",
        () => {
          // Set the back layer's background image to the new image.
          this.$refs.backLayer.style.backgroundImage = `url('${image}')`;

          // Set the back layer's background position to the focal point.
          this.$refs.backLayer.style.backgroundPosition = focalPoint;

          // Add the opacity-0 class back to the front layer.
          this.$refs.frontLayer.classList.add("opacity-0");
        },
        { once: true },
      );
    },
  };
};
